import React, { useEffect } from "react";
import _ from "lodash";
import {
  divVariants,
  bounce_right_to_left_variants
} from "shared/components/animations";
import { motion } from "framer-motion/dist/framer-motion";

import trophy from "assets/images/chpt/trophy.png";
import bannerCard from "assets/images/chpt/banner-card.png";
import winnerImg from "assets/images/chpt/winner-img.jpg";
import NonActiveReading from "../components/NonActiveReading";
const CHPTResult = ({
  winnerPlayerInfo,
  isActivePlayer,
  currentPlayerCard,
  isWinnerPlayer,
  default_audio_effect,
  buzzer_sound
}) => {

  useEffect(() => {
    if (isWinnerPlayer && !_.isEmpty(default_audio_effect)) {
      buzzer_sound();
    }
  }, [buzzer_sound, isActivePlayer, default_audio_effect]);
  return isActivePlayer ? (
    <motion.div variants={divVariants}
    initial="hidden"
    animate="visible"
    exit="exit"  className="winner">
      <motion.img variants={divVariants}  src={trophy} alt="trophy" />
      <motion.div variants={divVariants}  className="you-won">
        <img src={bannerCard} alt="bannerCard" />
        <h3>Winner!</h3>
      </motion.div>
      <motion.div variants={divVariants}   className="winner-card">
        <img src={winnerPlayerInfo?.profile_image} alr="winnerImg" />
        <h5>{winnerPlayerInfo?.display_name}</h5>
      </motion.div>
    </motion.div>
  ) : (
    <NonActiveReading currentPlayerCard={currentPlayerCard} />
  );
};

export default CHPTResult;
